import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/lib/analytics';
import { trackGAPageview } from '@/lib/gtag';

/**
 * Emits a PostHog `$pageview` AND a GA4 `page_view` whenever the
 * react-router location changes. Mounted once inside <BrowserRouter>
 * in App.tsx. Renders nothing. Each helper no-ops when its SDK isn't
 * initialised, so we don't need to check env vars here.
 */
export function PageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageview(window.location.href);
    trackGAPageview(window.location.href);
  }, [location.pathname, location.search]);

  return null;
}
